<template>
    <div class="create-page">
        <el-form ref="form" :model="form" label-position="top" class="create-card">
            <div class="page-heading">
                <span>ONLINE DOCUMENT SIGNING</span>
                <h1>创建签署文件</h1>
                <p>选择学生和本次需要签署的文件，系统将生成专属填写链接。</p>
            </div>

            <el-form-item label="学生名称">
                <el-input v-model="form.title" placeholder="用于标注文件所属学生"></el-input>
            </el-form-item>

            <section class="document-group department-group">
                <div class="group-heading">
                    <div><span>01</span><h2>小留之家部门文件签署</h2></div>
                    <p>学生资料与健康信息收集</p>
                </div>
                <el-checkbox-group v-model="form.tag" class="document-options">
                    <el-checkbox label="7" name="type"><strong>基本健康问卷</strong><small>Basic Health Survey</small></el-checkbox>
                    <el-checkbox label="8" name="type"><strong>学生档案</strong><small>Student Profile</small></el-checkbox>
                </el-checkbox-group>
                <div class="group-action">
                    <el-button
                        type="primary"
                        class="department-button"
                        :loading="creatingDepartment"
                        @click="createDepartmentDocuments"
                    >
                        进入小留之家部门文件签署
                    </el-button>
                </div>
            </section>

            <section class="document-group service-group">
                <div class="group-heading">
                    <div><span>02</span><h2>尚合后期服务系统签署</h2></div>
                    <p>入学、住家与授权类文件</p>
                </div>
                <el-checkbox-group v-model="form.tag" class="document-options">
                    <el-checkbox label="1" name="type"><strong>寄宿家庭项目协议</strong></el-checkbox>
                    <el-checkbox label="2" name="type"><strong>监护人授权和医药授权同意书</strong></el-checkbox>
                    <el-checkbox label="3" name="type"><strong>授权成绩单账户查询</strong></el-checkbox>
                    <el-checkbox label="4" name="type"><strong>外出知情及免责声明</strong></el-checkbox>
                    <el-checkbox label="5" name="type"><strong>独自乘坐飞机授权</strong></el-checkbox>
                    <el-checkbox label="6" name="type"><strong>入学文件确认页</strong></el-checkbox>
                </el-checkbox-group>
                <el-form-item v-if="form.tag.includes('1')" class="agreement-version" label="寄宿家庭协议版本">
                    <el-radio-group v-model="form.type">
                        <el-radio :label="1">C端</el-radio>
                        <el-radio :label="2">B端</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div class="group-action">
                    <el-button type="primary" class="service-button" @click="createServiceDocuments">
                        进入尚合后期服务系统签署
                    </el-button>
                </div>
            </section>
        </el-form>
    </div>
</template>

<script>
import { CreateDepartmentDocument, Generated } from "@/api/home"
export default {
    data() {
        return {
            form: {
                tag: [],
                title:"",
                type: 2
            },
            creatingDepartment: false
        }
    },
    methods: {
        validateTitle() {
            if(!this.form.title){
                this.$message({
                    message: '请填写文件所属学生名称',
                    type: 'warning'
                });
                return false
            }
            return true
        },
        errorMessage(error, fallback) {
            return (error.response && error.response.data && error.response.data.msg) || error.message || fallback
        },
        async createDepartmentDocuments() {
            if (!this.validateTitle()) return
            const departmentTags = this.form.tag.filter(tag => ["7", "8"].includes(tag));
            if (departmentTags.length === 0) {
                this.$message({
                    message: '请至少选择一份小留之家部门文件',
                    type: 'warning'
                });
                return
            }
            const documents = departmentTags.map(tag => tag === "7" ? "health" : "profile");
            this.creatingDepartment = true
            try {
                const response = await CreateDepartmentDocument({
                    title: this.form.title.trim(),
                    docs: documents
                })
                if (!response.data || !response.data.union_id) throw new Error('创建接口未返回 union_id')
                this.$router.push({
                    path: '/department-documents',
                    query: { union_id: response.data.union_id }
                });
            } catch (error) {
                this.$message.error(this.errorMessage(error, '创建签署任务失败，请稍后重试'))
            } finally {
                this.creatingDepartment = false
            }
        },
        createServiceDocuments() {
            if (!this.validateTitle()) return
            const serviceTags = this.form.tag.filter(tag => !["7", "8"].includes(tag));
            if (serviceTags.length === 0) {
                this.$message({
                    message: '请至少选择一份尚合后期服务文件',
                    type: 'warning'
                });
                return
            }
            Generated({
                tag: serviceTags,
                title: this.form.title,
                type: this.form.type
            }).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '合同生成成功',
                        type: 'success'
                    });


                    this.$router.push('/leave' + `?id=${res.data.id}`);
                }
            });

        }
    },
}
</script>

<style lang="scss" scoped>
.create-page { min-height: 100vh; padding: 48px 20px; background: #eef3f8; box-sizing: border-box; }
.create-card { max-width: 960px; margin: 0 auto; padding: 40px; border-radius: 14px; background: #fff; box-shadow: 0 18px 50px rgba(35, 53, 77, 0.1); }
.page-heading { margin-bottom: 34px; }
.page-heading span { color: #4779ad; font-size: 12px; font-weight: 700; letter-spacing: .16em; }
.page-heading h1 { margin: 7px 0 8px; color: #17243a; font-size: 30px; }
.page-heading p { margin: 0; color: #68768a; }
.document-group { margin: 26px 0; padding: 24px; border: 1px solid #dce5ef; border-radius: 10px; }
.department-group { border-top: 4px solid #3b82b9; }
.service-group { border-top: 4px solid #67768b; }
.group-heading { display: flex; align-items: flex-end; justify-content: space-between; gap: 20px; margin-bottom: 20px; }
.group-heading > div { display: flex; align-items: center; gap: 10px; }
.group-heading span { display: grid; width: 30px; height: 30px; place-items: center; border-radius: 50%; color: #fff; background: #315b8a; font-size: 12px; font-weight: 700; }
.group-heading h2 { margin: 0; color: #24354c; font-size: 20px; }
.group-heading p { margin: 0; color: #8a96a7; font-size: 13px; }
.document-options { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.document-options ::v-deep .el-checkbox { display: flex; align-items: flex-start; min-height: 54px; margin: 0; padding: 14px; border: 1px solid #e1e8f0; border-radius: 8px; white-space: normal; box-sizing: border-box; }
.document-options ::v-deep .el-checkbox.is-checked { border-color: #6aa0d1; background: #f1f7fc; }
.document-options strong, .document-options small { display: block; line-height: 1.45; }
.document-options small { color: #8793a3; }
.group-action { display: flex; justify-content: flex-end; margin-top: 20px; padding-top: 18px; border-top: 1px solid #e5ebf2; }
.group-action .el-button { min-width: 260px; height: 44px; font-size: 15px; }
.department-button { background: #397eb3; border-color: #397eb3; }
.service-button { background: #596b82; border-color: #596b82; }
.agreement-version { margin: 20px 0 0; }
@media (max-width: 700px) {
    .create-page { padding: 18px 10px; }
    .create-card { padding: 24px 16px; }
    .document-options { grid-template-columns: 1fr; }
    .group-heading { align-items: flex-start; flex-direction: column; }
    .group-action .el-button { width: 100%; min-width: 0; }
}
</style>
